module.exports = __webpack_public_path__ + "img/ygm_ico.3057369d.png";